<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="finanziamenti-list-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-tasso="{ value }">
      {{ value }}%
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.finanziamenti.edit', params: { finanziamentoId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'finanziamenti-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    finanziamenti: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'importo', label: 'Importo annuo' },
        { key: 'tasso', label: 'Tasso' },

        { key: 'tipoPianoName', label: 'Piano' },
        { key: 'frequenzaRateName', label: 'Frequenza rate' },

        { key: 'nbRate', label: 'Numero rate ammortamento' },
        { key: 'nbRatePreammortamento', label: 'Numero rate preammortamento' },

        { key: 'erogazione', label: 'Data erogazione' },
        { key: 'primaScadenza', label: 'Prima scadenza ammortamento' },
        { key: 'primaScadenzaPreammortamento', label: 'Prima scadenza preammortamento' },
      ];
    },
    tableRows () {
      return (this.finanziamenti || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
